import api from '~/api'

// 存储公用的state
export default {
  namespaced: true,
  state: {
    token: '',
    // 记录路由方向
    direction: '',
    // 记录当前用户的信息
    userInfo: '',
    // 控制全局loading
    loading: false
  },
  getters: {
    token: state => {
      return state.token || window.localStorage.getItem('token')
    },
    direction: state => state.direction,
    userInfo: state => state.userInfo,
    loading: state => state.loading
  },
  mutations: {
    updateToken(state, payload) {
      state.token = payload
      window.localStorage.setItem('token', payload)
    },
    updateDirection(state, payload) {
      state.direction = payload
    },
    updateUserInfo(state, payload) {
      state.userInfo = payload
    },
    updateLoading(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    updateToken(context, payload) {
      context.commit('updateToken', payload)
    },
    updateDirection(context, payload) {
      context.commit('updateDirection', payload)
    },
    updateUserInfo(context, payload) {
      context.commit('updateUserInfo', payload)
    },
    getMeInfo(context, payload) {
      return new Promise((resolve, reject) => {
        api.user.findMe().then(res => {
          context.commit('updateUserInfo', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    updateLoading(context, payload) {
      context.commit('updateLoading', payload)
    }
  }
}
